// Function definitions
const _mapPostcodeFee = function (postcode_fee){
    return postcode_fee;
};

const search = function(params = {}){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/postcode-fees', {
            params: params,
        }).then(xhr => {
            let postcode_fees = [];
            for (let index in xhr.data){
                postcode_fees.push(_mapPostcodeFee(xhr.data[index]));
            }
            xhr.data = postcode_fees;
            fulfill(xhr);
        }, error => {
            reject(error);
        })
    });
};

const get = function(id){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/postcode-fees/'+id).then(xhr => {
            xhr.data = _mapPostcodeFee(xhr.data);
            fulfill(xhr);
        }, error => {
            reject(error);
        });
    });
};

const create = function(postcode_fee){
    return window.axios.post('/api/postcode-fees', postcode_fee);
};

const update = function(postcode_fee){
    return window.axios.put('/api/postcode-fees/'+postcode_fee.id, postcode_fee);
};

const deletePostcodeFee = function(postcode_fee){
    return window.axios.delete('/api/postcode-fees/'+postcode_fee.id, postcode_fee);
};

export default {
    search,
    get,
    create,
    update,
    delete: deletePostcodeFee,
    _mapPostcodeFee,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/PostcodeFeeService.js